module.exports = __webpack_public_path__ + "static/media/intro_1.062006ea.png";